// @ts-nocheck
/**
 * Block/Inactivate-user confirmation dialog. Ported to shadcn ConfirmDialog
 * from the previous react-bootstrap version.
 *
 * Props contract preserved:
 *   { show, setShow, setConfirmUserInactive }
 */
import { AlertTriangle } from 'lucide-react';
import { ConfirmDialog } from '@/components/feedback/ConfirmDialog';

function RenderInactiveUserModal(props) {
  return (
    <ConfirmDialog
      open={!!props.show}
      onOpenChange={(next) => props.setShow(next)}
      title="Block this user?"
      description={
        <div className="space-y-2">
          <div className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-amber-900 dark:border-amber-900/40 dark:bg-amber-900/20 dark:text-amber-200">
            <AlertTriangle className="mt-0.5 h-4 w-4 flex-none" />
            <div className="text-sm">
              Blocking this user will also block every user nested under them.
              They will not be able to sign in until unblocked.
            </div>
          </div>
        </div>
      }
      confirmLabel="Block user"
      cancelLabel="Cancel"
      tone="destructive"
      onConfirm={() => props.setConfirmUserInactive(true)}
    />
  );
}

export default RenderInactiveUserModal;
